// extracted by mini-css-extract-plugin
export default {"container":"AlcoholCategories_container__nsWKW","heading":"AlcoholCategories_heading__z8jGk","alcoholCategoriesChart":"AlcoholCategories_alcoholCategoriesChart__uImI2"};